module.exports = __webpack_public_path__ + "static/img/PDF-Logo.a72abfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PDF-Logo.jpg
// module id = ZE+f
// module chunks = 1